<template>

  <div class="artist-page">
    <Header></Header>
    <section class="artists-heading-sectoin">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>Artists</h2>
          </div>
        </div>
        <form class="row form" v-on:submit.prevent="submitForm" enctype="multipart/form-data">
          <div class="col-md-4 profession-list">
            <div class="input-tags-field form-input">
              <label>Profession</label>
              <v-select :options="professionList" v-model="tag" />
            </div>
          </div>
          <div class="col-md-3 country-list">
            <label>Countries</label>
            <v-select :options="countriesList" v-model="country" />
          </div>
          <!--<div :class="{ 'col-md-3 ': citiesList.length > 1, 'col-md-3 hidden': citiesList.length <= 1 }">-->
            <!--<label>Cities</label>-->
            <!--<v-select :options="citiesList" v-model="city" />-->
          <!--</div>-->
          <div class="col-md-2">
            <div class="input-submit">
              <button type="submit" v-if="!filterAppliedFlaf">SEARCH</button>
              <span v-if="filterAppliedFlaf">SEARCH...</span>
            </div>
          </div>
        </form>
      </div>
    </section>

    <section class="artist-list" v-if="!filterFlag">
      <div class="container">
        <div class="row">
          <div class="col-md-3" v-if="!loading && list.profiles[0].profession && list.profiles[0].isfeatured" v-for="(list) in lists" v-bind:key="list._id">
            <div class="profile-b">
              <router-link :to="`artists/` + list._id" class="profile-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.profiles[0].images[0].profileImageFile})` }">
                <p>VIEW PROFILE <img src="@/assets/img/right_white_arrow.svg"/></p>
              </router-link>
              <h4>{{list.name}}</h4>
              <p v-if="list.profiles.length"><img src="@/assets/img/pin.svg"/> {{list.profiles[0].location}}<span v-if="list.profiles[0].country" class="pr-1">,</span>{{list.profiles[0].country}}</p>
            </div>
          </div>
          <div class="col-md-3" v-if="!loading && list.profiles[0].profession && !list.profiles[0].isfeatured" v-for="(list) in lists" v-bind:key="list._id">
            <div class="profile-b">
              <router-link :to="`artists/` + list._id" class="profile-img background-fit" :style="{ backgroundImage: `url(${imageUrl + list.profiles[0].images[0].profileImageFile})` }">
                <p>VIEW PROFILE <img src="@/assets/img/right_white_arrow.svg"/></p>
              </router-link>
              <h4>{{list.name}}</h4>
              <p v-if="list.profiles.length"><img src="@/assets/img/pin.svg"/> {{list.profiles[0].location}}<span v-if="list.profiles[0].country" class="pr-1">,</span>{{list.profiles[0].country}}</p>
            </div>
          </div>
        </div>
      </div>
    </section>


    <Footer></Footer>
  </div>
</template>

<style>
  @import "../assets/css/tagsinput.css";
  .hidden {
    display: none;
  }
</style>

<script>
import Header from './Header'
import Footer from './Footer'
import Loader from './include/Loader'
import backgroundUrl from '@/assets/img/image6.jpg'
import backgroundUrl2 from '@/assets/img/image1.jpg'
import backgroundUrl1 from '@/assets/img/team/dasha.png'
import contries from '@/assets/country.json'
import cities from '@/assets/cities.json'
import profession from '@/assets/profession.json'
import axios from 'axios'
import $ from "jquery"
import Vue from 'vue'
import VoerroTagsInput from '@voerro/vue-tagsinput'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/index.css'
import NoContent from "./include/NoContent";
Vue.use(VueToast)
import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";

export default {
  name: 'Artists',
  myJson: contries,
  myJsonCities: cities,
    myJsonProfession: profession,
  components: {
      NoContent,
    'Header': Header,
    'Footer': Footer,
    'Loader': Loader,
    'tags-input': VoerroTagsInput
  },
  mounted () {
      // AIzaSyBKmBMQDKbuFyuAgOnOa-RNUZPCjmuVQZ8
      // this.handleScriptLoad()

      // let arr = [];
      // $.each(this.$options.myJson, function (key, val) {
      //     arr.push(key)
      // })
      // console.log(JSON.stringify(arr))
      let $this = this
      $('.country-list .vs__search').change(function (event) {
          setTimeout(function () {
              $this.getCities()
          }, 300)
      });
      $('.country-list .vs__search').blur(function (event) {
          setTimeout(function () {
              if(!$('.country-list .vs__search').val()){
                  // $('.country-list .vs__search').val($this.allCountries)
              }
              $this.getCities()
          }, 300)
      });
      axios
          .get('/artists', {
              role: 'artist'
          })
          .then(response => {
              this.loading = false
              this.lists = response.data
              this.savedList = response.data
              this.getCountres()
          })
          .catch(error => {
              Vue.$toast.open(
                  {
                      message: error.response.data,
                      type: 'error',
                      position: 'top-right'
                      // all other options
                  }
              )
          })
  },
  methods: {
      handlePlaceSelect: function() {

          // Extract City From Address Object
          const addressObject = this.autocomplete.getPlace();
          const address = addressObject.address_components;

          // Check if address is valid
          if (address) {

              var componentForm = {
                  street_number: 'short_name',
                  route: 'long_name',
                  locality: 'long_name',
                  administrative_area_level_1: 'long_name',
                  postal_code: 'long_name'
              };

              for (var component in componentForm) {
                  document.getElementById(component).value = '';
                  document.getElementById(component).disabled = false;
              }

              for (var i = 0; i < address.length; i++) {
                  var addressType = address[i].types[0];
                  if (componentForm[addressType]) {
                      var val = address[i][componentForm[addressType]];
                      document.getElementById(addressType).value = val;
                  }
              }

              document.getElementsByClassName('block-address')[0].classList.remove('opacity');
              document.getElementById('search-container').classList.add('opacity');

              document.getElementById("autocomplete").addEventListener('focus', function(){
                  document.getElementById("search-container").classList.remove('opacity');
              });
              document.getElementById("autocomplete").addEventListener('focusout', function(){
                  document.getElementById("search-container").classList.add('opacity');
              });

              // console.log(address);
              // console.log(address.length);

              //923 Federal Rd, Iqaluit, Nunavut, Canada


          }
      },
      handleScriptLoad: function() {
          // Initialize Google Autocomplete
          /*global google*/ // To disable any eslint 'google not defined' errors
          this.autocomplete = new google.maps.places.Autocomplete(
              document.getElementById('autocomplete')
          );
          // Avoid paying for data that you don't need by restricting the set of
          // place fields that are returned to just the address components and formatted
          // address.
          this.autocomplete.setFields(['address_components', 'formatted_address']);
          // Fire Event when a suggested name is selected
          this.autocomplete.addListener('place_changed', this.handlePlaceSelect);
      },
      selectedTagFunction: function (event) {
          var tags = []
          this.selectedSkills.map(function(value, key) {
              tags.push(value.value)
          })
          this.tags = tags
      },
      submitForm: function () {
          this.filterAppliedFlaf = true
          let $this = this
          var filterList = []
          if(this.allCountries === $this.country){
              $this.country = ''
          }
          if(this.allProfession === $this.tag){
              $this.tag = ''
          }
          $.each(this.savedList, function (key, val) {
              if($this.city && $this.tag && $this.country){
                  if(val.profiles[0].location === $this.city){
                      if(val.profiles[0].profession && (val.profiles[0].profession === $this.tag)){
                          filterList.push(val)
                      }
                  }
              } else if($this.city && $this.tag){
                  if(val.profiles[0].location === $this.city){
                      if(val.profiles[0].profession && (val.profiles[0].profession === $this.tag)){
                          filterList.push(val)
                      }
                  }
              } else if($this.city){
                  if(val.profiles[0].location && (val.profiles[0].location === $this.city)){
                      filterList.push(val)
                  }
              } else if($this.country && $this.tag){
                  if(val.profiles[0].country === $this.country){
                      if(val.profiles[0].profession && (val.profiles[0].profession === $this.tag)){
                          filterList.push(val)
                      }
                  }
              } else if($this.country){
                  if(val.profiles[0].country && (val.profiles[0].country === $this.country)){
                      filterList.push(val)
                  }
              } else if($this.tag){
                  if(val.profiles[0].profession && (val.profiles[0].profession === $this.tag)){
                      filterList.push(val)
                  }
              }
          })

          if(!$this.country && !$this.tag){
              this.lists = this.savedList
          } else {
              this.lists = filterList
          }


          this.filterAppliedFlaf = false
          // axios
          //     .get('/artistFilter', {
          //         params: {
          //             skills: this.tags,
          //             location: this.location
          //         }
          //     })
          //     .then(response => {
          //         this.filterFlag = true
          //         this.loading = false
          //         this.filterAppliedFlaf = false
          //         this.lists = response.data
          //     })
          //     .catch(error => console.log(error))
      },
      getCountres: function(event){
          let $this = this
          $this.countriesList.push(this.allCountries)
          this.professionList.push(this.allProfession)
          this.professionList = this.professionList.concat($this.$options.myJsonProfession);
          // var list = []
          // $.each(this.professionList, function (key, val) {
          //     list.push(val.value)
          // })
          // this.professionList = list
          $.each(this.savedList, function (key, val) {
              if(val.profiles[0].country && !$this.countriesList.includes(val.profiles[0].country)){
                  $this.countriesList.push(val.profiles[0].country);
              }
          })
          setTimeout(function () {
              // $('.country-list .vs__search').val($this.allCountries)
              // $('.profession-list .vs__search').val($this.allProfession)
          }, 500)
      },
      getCities: function (event) {
          if(this.country !== this.allCountries){
              this.citiesList = this.$options.myJsonCities[this.country]
          } else {
              this.citiesList = []
          }
      }
  },
  data () {
    return {
        backgroundUrl: backgroundUrl,
        backgroundUrl1: backgroundUrl1,
        backgroundUrl2: backgroundUrl2,
        imageUrl: process.env.imageUrl,
        filterFlag: false,
        filterAppliedFlaf: false,
        loading: true,
        msg: 'Welcome to Your Vue.js App',
        lists: '',
        tag: '',
        savedList: '',
        selectedSkills: [],
        tags: [],
        location: '',
        country: '',
        city: '',
        allCountries: 'All Countries',
        allProfession: "All Artists",
        citiesList: ["Please select country first"],
        professionList: [],
        countriesList: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Artists.vue